import React, { useRef, useEffect } from "react"

import { applyVideoCloudinaryTransforms } from "utils/applyCloudinaryTransforms"

import {
  Container,
  StyledCard,
  ImageRegular,
  ImageCropped,
  Video,
  ImageHeadline,
  ImageOverlay,
} from "./styles"

const LinkCard = ({ hideOnPageLoad, headline, imageUrl, imageCrops, video, ...props }) => {
  const refCard = useRef(null)
  const refImage = useRef(null)
  const refVideo = useRef(null)

  useEffect(() => {
    const handlePlay = () => {
      if (refImage.current && refVideo.current) {
        refImage.current.style.opacity = 0
        refVideo.current.play()
      }
    }

    const handlePause = () => {
      if (refImage.current && refVideo.current) {
        refImage.current.style.opacity = 1
        refVideo.current.pause()
      }
    }

    if (refCard.current) {
      refCard.current.addEventListener("mouseenter", handlePlay)
      refCard.current.addEventListener("mouseleave", handlePause)
    }

    return () => {
      if (refCard.current) {
        refCard.current.removeEventListener("mouseenter", handlePlay)
        refCard.current.removeEventListener("mouseleave", handlePause)
      }
    }
  }, [])

  const mediaWidthDesktop = 253
  const mediaHeightDesktop = 377
  const mediaWidthMobile = 390
  const mediaHeightMobile = 140

  const imageElement = imageUrl ? (
    <ImageRegular
      elRef={refImage}
      variant="4col"
      baseUrl={imageUrl}
      alt={headline}
      images={[
        {
          screenSize: 576,
          transforms: `c_fit,w_${mediaWidthDesktop},h_${mediaHeightDesktop},q_auto,fl_lossy,f_auto`,
        },
        {
          transforms: `c_fill,g_auto,w_${mediaWidthMobile},h_${mediaHeightMobile},q_auto,f_auto,fl_lossy`,
        },
      ]}
      lazy
      isGrid
      imagePosition="top"
    />
  ) : imageCrops ? (
    <ImageCropped
      elRef={refImage}
      variant="4col"
      imageData={imageCrops}
      alt={headline}
      sizes={[
        {
          query: 576,
          width: mediaWidth,
          height: mediaHeight,
          transforms: `c_fill,g_auto,w_${mediaWidthDesktop},h_${mediaHeightDesktop},q_auto,f_auto,fl_lossy`,
        },
        {
          query: 0,
          width: mediaWidth,
          height: mediaHeight,
          transforms: `c_fill,g_auto,w_${mediaWidthMobile},h_${mediaHeightMobile},q_auto,f_auto,fl_lossy`,
        },
      ]}
      lazy
      isGrid
      imagePosition="top"
    />
  ) : null

  const videoElement = video && (
    <Video
      ref={refVideo}
      width="100%"
      muted={video.muteAudio}
      loop={video.loopVideo}
      playsInline
      type="video/mp4"
      src={applyVideoCloudinaryTransforms(
        video.videoObject[0].secure_url,
        `ac_none,c_fill,w_${mediaWidthDesktop},h_${mediaHeightDesktop}`,
      )}
    />
  )

  return (
    <Container>
      <StyledCard
        {...props}
        elRef={refCard}
        hideOnPageLoad={hideOnPageLoad}
        headline={headline}
        headlineOverride={
          <>
            <ImageHeadline variant="medium">{headline} →</ImageHeadline>
            <ImageOverlay />
          </>
        }
        imageOverride={imageElement}
        video={videoElement}
      />
    </Container>
  )
}

export default LinkCard
